module.exports = __webpack_public_path__ + "img/honor_001.39e55e1.webp";